import { createSlice } from "@reduxjs/toolkit";

export const orderSlice = createSlice({
  name: "order",
  initialState: {
    isLoading: false,

    orderData: [],

    message: "",
  },
  reducers: {
    onGetOrder: (state) => {
      return {
        ...state,
        isLoading: true,

        orderData: [],

        message: "",
      };
    },

    onGetOrderSuccess: (state, { payload }) => {
      const { data = [], status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,

        orderData: data,

        status_code,
      };
    },

    onGetOrderError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400, errorCode = 1456 } = payload;
      return {
        ...state,
        orderData: data,
        message,
        status_code,
        errorCode,
        isLoading: false,
      };
    },
    onGetOrderReset: (state) => {
      return {
        ...state,
        isLoading: false,
        orderData: [],
        message: "",
        errorCode: null,

        status_code: null,
      };
    },
    onPostOrder: (state) => {
      return {
        ...state,
        isLoading: true,

        postOrderData: [],

        postMessage: "",
      };
    },
    onPostOrderSuccess: (state, { payload }) => {
      const { postData = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        postOrderData: postData,
        postMessage: message,
        post_status_code: status_code,
      };
    },

    onPostOrderError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400, errorCode = 1456 } = payload;

      return {
        ...state,
        postOrderData: data,
        postMessage: message,
        post_status_code: status_code,
        isLoading: false,
        errorCode: errorCode
      };
    },
    onPostOrderReset: (state) => {
      return {
        ...state,
        isLoading: false,
        postMessage: "",
        errorCode: null,
        post_status_code: null,
      };
    },

    onUpdateOrder: (state) => {
      return {
        ...state,
        isLoading: true,

        updatedOrderData: {},

        updateMessage: "",
      };
    },

    onUpdateOrderSuccess: (state, { payload }) => {
      const { data = {}, message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,

        updatedOrderData: data,
        updateMessage: message,
        update_status_code: status_code,
      };
    },

    onUpdateOrderError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        updatedOrderData: data,
        updateMessage: message,
        update_status_code: status_code,
        isLoading: false,
      };
    },
    onUpdateOrderReset: (state) => {
      return {
        ...state,
        isLoading: false,
        updateMessage: "",
        update_status_code: null,
      };
    },
    onUpdateOrderSuccessReset: (state) => {
      return {
        ...state,
        isLoading: false,
        updatedOrderData: [],
        updateMessage: "",
        update_status_code: null,
      };
    },
    onPendingOrderReset: (state) => {
      return {
        ...state,
        isLoading: false,
        updatedOrderData: [],
        orderData: [],
        updateMessage: "",
        update_status_code: null,
      };
    },
  },
});
export const {
  onGetOrder,
  onGetOrderSuccess,
  onGetOrderError,
  onGetOrderReset,
  onPostOrder,
  onPostOrderSuccess,
  onPostOrderError,
  onPostOrderReset,
  onUpdateOrder,
  onUpdateOrderSuccess,
  onUpdateOrderError,
  onUpdateOrderReset,
  onUpdateOrderSuccessReset,
  onPendingOrderReset
} = orderSlice.actions;

export default orderSlice.reducer;
